import React from 'react';
import Linklist from '../platformui/Linklist';

export default (props) => (
  <Linklist Modifiers={{ 'c-linklist--block': true }} {...props} />
);
